import React from 'react';
import { SegmentedControl } from '@components/primitives/SegmentedControl';
import { useEventTracking } from '@services/statsig';

import { useOrgScheduleAccess } from '../hooks/useOrgScheduleAccess';
import { useOrgScheduleFilters } from '../hooks/useOrgScheduleFilters';

/**
 * Segmented toggle for switching between personal and org-wide calendar views.
 * Self-gates: returns null when the user lacks org schedule access.
 */
export const OrgScheduleToggle: React.FC = () => {
  const { hasOrgScheduleAccess } = useOrgScheduleAccess();
  const { isOrgViewActive, toggleOrgView } = useOrgScheduleFilters();
  const { orgSchedule } = useEventTracking();

  if (!hasOrgScheduleAccess) return null;

  const options = [
    { value: 'my', label: 'My Schedule' },
    { value: 'org', label: 'Practice' },
  ];

  const handleChange = (value: string) => {
    const toggledTo = value === 'org' ? 'org' : 'my';
    toggleOrgView(value === 'org');
    orgSchedule.viewToggled({ toggled_to: toggledTo });
  };

  return (
    <SegmentedControl
      options={options}
      value={isOrgViewActive ? 'org' : 'my'}
      onChange={handleChange}
      size="small"
      ariaLabel="Schedule view scope"
    />
  );
};
